import { useLoginPageLogic } from 'hooks/page-logic/income-insurance';
import type { PropsWithChildren } from 'react';

import { LoginPageContext } from './LoginPageContext';

export const LoginPageLogicProvider = ({ children }: PropsWithChildren) => {
  const value = useLoginPageLogic();

  return (
    <LoginPageContext.Provider value={value}>
      {children}
    </LoginPageContext.Provider>
  );
};
